export function StyleLineHeight (pEditor, pStyle)
{
  let prevLineHeight;


  this.getCurrentLineHeight = () =>
  {
    let lineHeight;

    if (BEditor.browser.isIE && ((pEditor.pToolbar && pEditor.pToolbar.isMouseDown) || pEditor.isDropdownOpen) && prevLineHeight != null)
    {
      return prevLineHeight;
    }

    lineHeight = pStyle.helpers.getCurrentStyleInRange('lineHeight');

    if (lineHeight != null && lineHeight !== '' && lineHeight.toLowerCase() !== 'normal')
    {
      lineHeight = normalizeLineHeight(lineHeight);
    }
    else
    {
      lineHeight = 'Auto'
    }

    prevLineHeight = lineHeight;
    return lineHeight;
  };


  function normalizeLineHeight (lineHeight, element)
  {
    let height,
        fontSize,
        matchLineHeight = lineHeight.match(/^(\d*\.?\d*)(px|em|pt|%)$/);

    if (matchLineHeight && matchLineHeight.length === 3)
    {
      height = parseFloat((((/(?:em|pt|%)/i).test(matchLineHeight[2])) ? BEditor.styleHelpers.currentStyleUnitNormalizer(matchLineHeight[1], matchLineHeight[2]) : matchLineHeight[1]));
    }
    else
    {
      height = parseFloat(lineHeight);

      if (element)
      {
        fontSize = BEditor.styleHelpers.getElementStyleInt(element, 'fontSize', pEditor.iFrame);
        height = !isNaN(height) ? fontSize * height : fontSize;
      }
      else
      {
        height = 12;
      }
    }

    return (!isNaN(height) ? Math.round(height) : 'Auto');
  }


  const checkBlockSpaces = () =>
  {
    let reTrueBlockNodes = /^(?:P|H[1-6]|UL|OL)$/i,
        currentRange = pEditor.range.getCurrent(true);

    if (currentRange)
    {
      const nodeList = pEditor.helpers.element.getElementsInRangeByTagsNames(currentRange, reTrueBlockNodes, true);

      if (nodeList && nodeList.length > 0)
      {
        let node = nodeList[0],
            prevSibling = pEditor.helpers.dom.getRealSibling(node.previousSibling, 'previousSibling'),
            nextSibling = pEditor.helpers.dom.getRealSibling(node.nextSibling, 'nextSibling'),
            isAddBefore = (BEditor.styleHelpers.getElementStyleInt(node, 'marginTop', pEditor.iFrame) === 0 && !(prevSibling && reTrueBlockNodes.test(prevSibling.nodeName) && (BEditor.styleHelpers.getElementStyleInt(prevSibling, 'marginBottom', pEditor.iFrame) !== 0))),
            isAddAfter = (BEditor.styleHelpers.getElementStyleInt(node, 'marginBottom', pEditor.iFrame) === 0 && !(nextSibling && reTrueBlockNodes.test(nextSibling.nodeName) && (BEditor.styleHelpers.getElementStyleInt(nextSibling, 'marginTop', pEditor.iFrame) !== 0)));

        return [node.tagName, isAddBefore, isAddAfter];
      }
    }

    return [null, false, false];
  };


  this.openLineHeightDropdown = (pButton) =>
  {
    const tagsPhrase =
          {
            'P':  'paragraph',
            'H1': 'heading',
            'H2': 'heading',
            'H3': 'heading',
            'H4': 'heading',
            'H5': 'heading',
            'H6': 'heading',
            'UL': 'list',
            'OL': 'list'
          };

    pEditor.pDropdown = pButton.getDropdown();

    if (!pEditor.pDropdown)
    {
      return false;
    }

    if (pEditor.pDropdown.getState())
    {
      pEditor.closeDropdown(pButton);
    }
    else
    {
      let [tagName, isAddBefore, isAddAfter] = checkBlockSpaces(),
          idSpaceBeforeBlock = `${(isAddBefore ? 'Add' : 'Remove')}SpaceBeforeBlock`,
          labelSpaceBeforeBlock = (tagName !== null) ? `${(isAddBefore ? 'Add' : 'Remove')} space before ${tagsPhrase[tagName]}` : 'Remove space before paragraph',
          idSpaceAfterBlock = `${(isAddAfter ? 'Add' : 'Remove')}SpaceAfterBlock`,
          labelSpaceAfterBlock = (tagName !== null) ? `${(isAddAfter ? 'Add' : 'Remove')} space after ${tagsPhrase[tagName]}` : 'Remove space after paragraph';
      pEditor.pDropdown.setReturnedParameters('selectedStyleId', '');
      pEditor.openDropdown(pButton, pEditor.pDropdown, 'setLineHeight', {'ddArgs': {'isLineHeightDropdown': true, 'fontSize': pEditor.font.size.getCurrentFontSize(), 'isSpaceBlock': !!tagName, idSpaceBeforeBlock, labelSpaceBeforeBlock, idSpaceAfterBlock, labelSpaceAfterBlock}});
    }
  };


  const setSpaceBeforeAfterBlock = (isAddSpace, isSpaceBefore) =>
  {
    let firstMargin = (isSpaceBefore ? 'marginTop' : 'marginBottom'),
        firstMarginCss = (isSpaceBefore ? 'margin-top' : 'margin-bottom'),
        secondMargin = (isSpaceBefore ? 'marginBottom' : 'marginTop'),
        secondMarginCss = (isSpaceBefore ? 'margin-bottom' : 'margin-top'),
        reTrueBlockNodes = /^(?:P|H[1-6]|UL|OL)$/i,
        currentRange = pEditor.range.getCurrent(true);

    if (currentRange)
    {
      const nodeList = pEditor.helpers.element.getElementsInRangeByTagsNames(currentRange, reTrueBlockNodes);

      for (let i = 0; i < nodeList.length; i++)
      {
        let sibling = pEditor.helpers.dom.getRealSibling(nodeList[i][(isSpaceBefore ? 'previousSibling' : 'nextSibling')], (isSpaceBefore ? 'previousSibling' : 'nextSibling'));

        if (sibling && !reTrueBlockNodes.test(sibling.nodeName))
        {
          sibling = null;
        }

        if (isAddSpace)
        {
          nodeList[i].style.removeProperty(firstMarginCss);

          if (BEditor.styleHelpers.getElementStyleInt(nodeList[i], firstMargin, pEditor.iFrame) === 0)
          {
            nodeList[i].style.setProperty(firstMarginCss, '1em', 'important');
          }

          if (sibling && parseInt(sibling.style[secondMargin]) === 0)
          {
            sibling.style.removeProperty(secondMarginCss);
          }
        }
        else
        {
          nodeList[i].style.removeProperty(firstMarginCss);

          if (BEditor.styleHelpers.getElementStyleInt(nodeList[i], firstMargin, pEditor.iFrame) > 0)
          {
            nodeList[i].style.setProperty(firstMarginCss, '0', 'important');
          }

          if (sibling)
          {
            sibling.style.removeProperty(secondMarginCss);

            if (BEditor.styleHelpers.getElementStyleInt(sibling, secondMargin, pEditor.iFrame) > 0)
            {
              sibling.style.setProperty(secondMarginCss, '0', 'important');
            }
          }
        }
      }
    }
  };


  function setLineHeight (pButton, lineHeight)
  {
    let i,
        currentSelection,
        currentRange,
        startParentBlockElement,
        endParentBlockElement,
        lineHeightId,
        startContainer,
        endContainer,
        blockElement,
        sibling,
        elements = [],
        pParameters;

    pEditor.pDropdown = pButton.getDropdown();

    if (lineHeight)
    {
      lineHeightId = lineHeight;
    }
    else
    {
      if (pEditor.pDropdown)
      {
        pParameters = pEditor.pDropdown.getReturnedParameters();
      }

      if (pParameters && pParameters.selectedStyleId != null)
      {
        lineHeightId = pParameters.selectedStyleId;
      }

      pEditor.closeDropdown(pButton);
    }

    if (lineHeightId != null)
    {
      pEditor.range.stopCheckSelection();

      lineHeightId += '';

      if (lineHeightId.indexOf('Space') !== -1)
      {
        setSpaceBeforeAfterBlock((lineHeightId.indexOf('Add') === 0), (lineHeightId.indexOf('Before') !== -1));
      }
      else
      {
        currentSelection = pEditor.range.selection.getCurrent(true);
        currentRange = pEditor.range.getCurrent(true);

        if (currentSelection && currentRange)
        {
          startContainer = currentRange.startContainer;
          endContainer = currentRange.endContainer;

          if (startContainer.nodeName === 'BODY' && endContainer.nodeName === 'BODY' && currentRange.startOffset === 0 && currentRange.endOffset >= endContainer.children.length)
          {
            startContainer = startContainer.firstChild;
            endContainer = endContainer.lastChild;
          }
          else
          {
            if (startContainer.nodeName === 'BODY')
            {
              if (startContainer.children && startContainer.children[currentRange.startOffset - 1])
              {
                startContainer = startContainer.children[currentRange.startOffset - 1];
              }
              else
              {
                startContainer = null;
              }
            }

            if (endContainer.nodeName === 'BODY')
            {
              if (endContainer.children && endContainer.children[currentRange.endOffset - 1])
              {
                endContainer = endContainer.children[currentRange.endOffset - 1];

                if (!startContainer)
                {
                  startContainer = endContainer;
                }
              }
              else
              {
                if (startContainer)
                {
                  endContainer = startContainer;
                }
                else
                {
                  return false;
                }
              }
            }
          }

          startParentBlockElement = pEditor.helpers.element.getParentElementFromElementByTagsNames(startContainer, pEditor.checkAllBlockTagsExt);
          endParentBlockElement = pEditor.helpers.element.getParentElementFromElementByTagsNames(endContainer, pEditor.checkAllBlockTagsExt);

          if (startParentBlockElement && startParentBlockElement.nodeName === 'BODY' && endParentBlockElement && endParentBlockElement.nodeName === 'BODY')
          {
            blockElement = pEditor.helpers.dom.moveTextInToTag(startContainer, 'P', {
              'isTrim': true,
              'compareNode': endContainer
            });
            startParentBlockElement = (blockElement ? blockElement.element : startContainer.nextElementSibling);

            if (!blockElement || !blockElement.isNodeEqual)
            {
              blockElement = pEditor.helpers.dom.moveTextInToTag(endContainer, 'P', {'isTrim': true});
              endParentBlockElement = (blockElement ? blockElement.element : startContainer.previousElementSibling);
            }
            else
            {
              endParentBlockElement = startParentBlockElement;
            }
          }
          else if (startParentBlockElement && startParentBlockElement.nodeName === 'BODY')
          {
            blockElement = pEditor.helpers.dom.moveTextInToTag(startContainer, 'P', {'isTrim': true});
            startParentBlockElement = (blockElement ? blockElement.element : startContainer.nextElementSibling);
          }
          else if (endParentBlockElement && endParentBlockElement.nodeName === 'BODY')
          {
            blockElement = pEditor.helpers.dom.moveTextInToTag(endContainer, 'P', {'isTrim': true});
            endParentBlockElement = (blockElement ? blockElement.element : startContainer.previousElementSibling);
          }

          elements.splice(0, elements.length);
          sibling = startParentBlockElement;

          while (sibling && sibling !== endParentBlockElement)
          {
            if (pEditor.checkAllBlockTagsExt.test(sibling.nodeName))
            {
              elements.push(sibling);
            }

            sibling = sibling.nextSibling;

            if (sibling && !pEditor.checkAllBlockTagsExt.test(sibling.nodeName) && (sibling.nodeType === 1 || (sibling.nodeType === 3 && sibling.nodeValue && sibling.nodeValue.replace(/\s+/, '') !== '')))
            {
              blockElement = pEditor.helpers.dom.moveTextInToTag(sibling, 'P', {'isTrim': true});

              if (blockElement)
              {
                sibling = blockElement.element;
              }
            }
          }

          if (endParentBlockElement)
          {
            elements.push(endParentBlockElement);
          }

          for (i = 0; i < elements.length; i++)
          {
            if (lineHeightId === 'auto')
            {
              elements[i].style.lineHeight = '';

              if (elements[i].getAttribute('style') === '')
              {
                elements[i].removeAttribute('style');
              }
            }
            else
            {
              elements[i].style.lineHeight = lineHeightId + 'px';
            }
          }
        }
      }

      pEditor.range.restoreBookmark();
    }
  }


  this.normalizeLineHeight = normalizeLineHeight;
  this.setLineHeight = setLineHeight;
}